const handlersCollection = new Map();

export default handlersCollection;
